import { uniq } from "lodash";
import { ITplWarningText } from "../components/tpl-omdestinera/tpl-omdestinera.models";
import { ITplArbetsorder } from "./dtos";
import { ITransportforetag } from "./queries";

export class TplArbetsorderViewModel {

    ansvarigtTransportforetag: string;
    transportforetagList: string[];
    isDelad: boolean;
    hasBefraktare: boolean;
    hasMultipleBefraktare: boolean;
    befraktareColors: string[];

    selected = false;
    warnings: ITplWarningText[] = [];

    private hover = false;
    private doShowWarning = false;
    private warning = false;
    private warningClicked = false;

    constructor(
        readonly model: ITplArbetsorder,
        readonly resolveTransportforetag: (id: number) => ITransportforetag,
        readonly resolveBefraktare: (id: number) => string,
        readonly resolveHasBefraktareAndAreDifferent: (ao: ITplArbetsorder) => boolean) {
        this.init();
    }

    setTransportforetag(transportforetagId: number) {
        this.model.transportforetagId = transportforetagId;
        this.model.color = this.resolveTransportforetag(transportforetagId)?.color ?? "#ffffff";

        this.init();
    }

    setHandelssortimentTransportforetag(handelssortimentId: number, transportforetagId: number, befraktareId: number, egenTransport: boolean) {
        const handelssortiment = this.model.handelssortiment.find(x => x.handelssortimentId === handelssortimentId);
        if (!handelssortiment) {
            return;
        }

        handelssortiment.transportforetagId = transportforetagId;
        handelssortiment.befraktareId = befraktareId;
        handelssortiment.egenTransport = egenTransport;

        this.init();
    }

    init(): void {
        const model = this.model;
        const aotransportforetag = model.transportforetagId ? this.getTransportforetagNamn(model.transportforetagId) : null;
        const hstransportforetag = model.handelssortiment
            .filter(x => !!x.transportforetagId && x.transportforetagId !== model.transportforetagId)
            .map(hs => this.getTransportforetagNamn(hs.transportforetagId));

        const hsBefraktare = model.handelssortiment
            .filter(x => !!x.befraktareId)
            .map(hs => this.getBefraktareNamn(hs.befraktareId));

        const transportforetag = [
            ...hstransportforetag,
            ...hsBefraktare
        ];

        this.ansvarigtTransportforetag = aotransportforetag;
        this.transportforetagList = uniq(transportforetag);

        this.isDelad = this.hasHandelssortimentTilldelning();
        this.hasBefraktare = this.hasBefraktareTilldelning();
        this.hasMultipleBefraktare = this.aoHasBefraktareAndAreDifferent();
        this.befraktareColors = this.getBefraktareColors();
    }

    clearWarnings() {
        this.warnings.splice(0);
    }

    get id() {
        return this.model.id;
    }

    get beteckning() {
        return this.model.beteckning;
    }

    get isTerminalImport(): boolean {
        return this.model.isTerminalImport;
    }

    get namn() {
        return this.model.namn;
    }

    get produktionsstatus() {
        return this.model.produktionsstatus;
    }

    get easting() {
        return this.model.easting;
    }

    get northing() {
        return this.model.northing;
    }

    get isSelected() {
        return this.selected;
    }

    set isSelected(val: boolean) {
        this.selected = val;
    }

    get isHover() {
        return this.hover;
    }

    set isHover(val: boolean) {
        this.hover = val;
    }

    get transportforetagId() {
        return this.model.transportforetagId;
    }

    get produktionsomradeId() {
        return this.model.produktionsomradeId;
    }

    get handelssortimentIdn(): number[] {
        return this.model.handelssortiment.map(hs => hs.handelssortimentId);
    }

    get showWarning() {
        return this.doShowWarning;
    }

    set showWarning(value: boolean) {
        this.doShowWarning = value;
    }

    get warningEnabled() {
        return this.warning;
    }

    set warningEnabled(value: boolean) {
        this.warning = value;
    }

    get hasClickedWarning() {
        return this.warningClicked;
    }

    set hasClickedWarning(value: boolean) {
        this.warningClicked = value;
    }

    get harAktivVirkesorderVals() {
        return this.model.harAktivVirkesorderVals;
    }

    get viol3() {
        return this.model.viol3;
    }

    private getTransportforetagNamn(transportforetagId: number): string {
        if (this.resolveTransportforetag === null) {
            return null;
        }

        const transportforetag = this.resolveTransportforetag(transportforetagId);
        if (!transportforetag) {
            return null;
        }
        if (!transportforetag.huvudkod) {
            return transportforetag.namn;
        }
        return `${transportforetag.huvudkod} ${transportforetag.namn}`;
    }

    private getBefraktareNamn(befraktareId: number): string {
        if (this.resolveBefraktare === null) {
            return null;
        }

        return this.resolveBefraktare(befraktareId);
    }

    private hasHandelssortimentTilldelning() {
        return this.model.handelssortiment.some(x => !!x.transportforetagId || !!x.befraktareId);
    }

    private hasBefraktareTilldelning() {
        return this.model.handelssortiment.some(x => !!x.befraktareId);
    }

    private aoHasBefraktareAndAreDifferent() {
        if(this.resolveHasBefraktareAndAreDifferent === null) {
            return false;
        }

        return this.resolveHasBefraktareAndAreDifferent(this.model);
    }

    private getBefraktareColors(): string[] {
        return this.model.handelssortiment.filter(x => x.befraktareColor).map(x => x.befraktareColor) || [];
    }
}
